import React, { Component } from "react";
import { Card, Cascader } from "antd";
import Request from "../../networkReq/request";
import Http from "../../networkReq/http";
import {
  getCitys,
  getCurrentUser,
  removeAll,
  setCitys,
} from "../../utils/storage";

export default class Cascaders extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // defaultValue: this.props.defaultValue ? this.props.defaultValue : [],
      allCitys: this.props.allCitys ? true : false,
      neimeng: this.props.neimeng ? true : false,
      meishan: this.props.meishan ? true : false,
      bespread: this.props.bespread ? true : false,
      citys: [],
      deptId: [],
      deptName: [],
    };
  }

  //重置方法
  resetDefaultValue() {
    let { allCitys } = this.state;
    let { onChange } = this.props;
    if (allCitys) {
      console.log("deptId");
      let temp = {
        provinceId: "",
        provinceName: "",
        cityId: "",
        cityName: "",
        countyId: "",
        countyName: "",
      };
      this.setState(
        {
          defaultValue: [],
        },
        () => onChange && onChange(temp)
      );
    } else {
      this.getCityId();
    }
  }

  componentDidMount = () => {
    let { allCitys } = this.state;
    if (allCitys) {
      this.getAllCitys();
    } else {
      let getuser = getCurrentUser();
      if (getuser) {
        this.setState(
          {
            citys: getCitys(),
            deptId: getuser.org_id.split(","),
          },
          () => this.getCityId(),
          this.disabledCity()
        );
      } else {
        removeAll();
        // this.props.history.push('/user/login');
      }
    }
  };

  getAllCitys() {
    let orgId = "";
    if (this.state.neimeng) {
      orgId = "150000000000";
    }
    if (this.state.meishan) {
      orgId = "511400000000";
    }
    Http.get(Request.getCityList(), { orgId: orgId }, (val) => {
      if (val && val.code == 200) {
        setCitys(val.data);
        console.log("val.data", val.data);

        this.setState({
          citys: val.data,
        });
      }
    });
  }

  //禁止选择   长度= 2 为市级管理员，限制省级不能选，只能选择当前登录的市级或下级区县
  disabledCity() {
    let { citys, deptId } = this.state;
    if (deptId.length == 2) {
      citys[0].disabled = true;
      this.setState({
        citys: citys,
      });
    }
  }

  //新增，查询回调当前登录的账号地市权限
  getCityId() {
    const { onChange, defaultValue } = this.props;
    let { deptId, deptName } = this.state;
    let length = deptId.length;
    let nameLength = deptName.length;
    console.log("deptId", deptId);
    console.log("deptName", deptName);
    let temp = {
      provinceId: deptId[0],
      provinceName: nameLength > 1 ? deptName[0] : "",
      cityId: length > 1 ? deptId[1] : "",
      cityName: nameLength > 1 ? deptName[1] : "",
      countyId: length > 2 ? deptId[2] : "",
      countyName: nameLength > 1 ? deptName[2] : "",
    };
    if (!defaultValue) {
      this.setState(
        {
          defaultValue: deptId,
        },
        () => onChange && onChange(temp)
      );
    }
  }

  componentWillReceiveProps(nextProps, nextContext) {
    let { citys, deptId } = this.state;
    let { defaultValue } = nextProps;
    // console.log('deptId', deptId)
    //详情回显   如果是区县级别  只回显当前的权限不能更改
    if (deptId.length < 3) {
      if (
        defaultValue &&
        JSON.stringify(defaultValue) !== JSON.stringify(this.props.defaultValue)
      ) {
        this.setState({
          defaultValue: defaultValue,
        });
      }
    } else {
      this.setState({
        defaultValue: deptId,
      });
    }
  }

  //选择回调
  onChangeCity = (value, selectedOptions) => {
    const { onChange } = this.props;
    let { allCitys, meishan } = this.state;
    let isHaveChildren = false;
    if (allCitys) {
      if (selectedOptions[selectedOptions.length - 1].children.length > 0) {
        isHaveChildren = true;
      } else {
        isHaveChildren = false;
      }
    }
    console.log("value", value);
    console.log("selectedOptions", selectedOptions);

    let m = meishan ? 0 : 1;
    let n = meishan ? 1 : 2;

    let length = selectedOptions.length;
    let temp = {
      provinceId: meishan ? "510000000000" : selectedOptions[0].value,
      provinceName: meishan ? "四川省" : selectedOptions[0].label,
      cityId: length > m ? selectedOptions[m].value : "",
      cityName: length > m ? selectedOptions[m].label : "",
      countyId: length > n ? selectedOptions[n].value : "",
      countyName: length > n ? selectedOptions[n].label : "",
    };

    // console.log('defaultValue', value)
    this.setState(
      {
        defaultValue: value,
      },
      () => onChange && onChange(temp, allCitys ? isHaveChildren : null)
    );
  };

  render() {
    const { citys, deptId, allCitys, bespread } = this.state;
    const { disabled, defaultValue, option } = this.props;
    console.log("citys:", citys);
    console.log("valuevaluevaluevalue", defaultValue);

    return (
      <Cascader
        style={{ width: bespread ? "100%" : "80%" }}
        options={option ? option : citys}
        // disabled={deptId.length == 3 || disabled == '1' ? true : false}
        allowClear={false}
        // displayRender={(label, selectedOptions) => this.setState({deptName:label})}
        placeholder="请选择地区"
        value={defaultValue}
        onChange={this.onChangeCity}
        changeOnSelect
      />
    );
  }
}
